import React from 'react'
import { DatePicker, Empty, Popconfirm } from 'antd'
import { LoadingOutlined, RocketOutlined } from '@ant-design/icons'
import {
  GenerateAllButton,
  GenerationToolbar,
  ResultsCount,
  ToolbarDivider,
  ToolbarGroup,
  ToolbarLabel,
  ToolbarSpacer,
} from './InvoiceGenerationView.styles'
import { GeneratedInvoiceTable } from './GeneratedInvoiceTable'
import { GeneratedInvoiceDrawer } from './GeneratedInvoiceDrawer'
import useInvoiceGeneration from './useInvoiceGeneration'

const InvoiceGenerationView: React.FC = () => {
  const {
    selectedMonth,
    setSelectedMonth,
    rows,
    total,
    isLoading,
    isError,
    expandedRowKeys,
    setExpandedRowKeys,
    drawerInvoiceId,
    selectedInvoice,
    handleOpenDrawer,
    handleCloseDrawer,
    handleGenerateAll,
    handleRegenerate,
    isGeneratingAll,
    isRegenerating,
    regeneratingInvoiceKey,
  } = useInvoiceGeneration()

  return (
    <>
      <GenerationToolbar>
        <ToolbarGroup>
          <ToolbarLabel>Billing month</ToolbarLabel>
          <DatePicker
            picker="month"
            value={selectedMonth}
            onChange={(date) => {
              if (date) setSelectedMonth(date.startOf('month'))
            }}
            format="MMM YYYY"
            allowClear={false}
          />
        </ToolbarGroup>

        <ToolbarDivider />
        <Popconfirm
          title="Generate all invoices"
          description={`Generate (or regenerate) invoices for funded month ${selectedMonth.format('MMM YYYY')}?`}
          onConfirm={handleGenerateAll}
          okText="Generate all"
          cancelText="Cancel"
        >
          <GenerateAllButton disabled={isGeneratingAll}>
            {isGeneratingAll ? <LoadingOutlined spin /> : <RocketOutlined />}
            Generate all
          </GenerateAllButton>
        </Popconfirm>

        <ToolbarSpacer />
        <ResultsCount>
          {rows.length} of {total} generated invoices
        </ResultsCount>
      </GenerationToolbar>

      {isError ? (
        <Empty description="Failed to load generated invoices." />
      ) : (
        <GeneratedInvoiceTable
          invoices={rows}
          isLoading={isLoading}
          expandedRowKeys={expandedRowKeys}
          onExpandedRowKeysChange={setExpandedRowKeys}
          onOpenDetail={handleOpenDrawer}
          onRegenerate={handleRegenerate}
          isRegenerating={isRegenerating}
          regeneratingInvoiceKey={regeneratingInvoiceKey}
        />
      )}

      <GeneratedInvoiceDrawer
        invoiceId={drawerInvoiceId}
        selectedInvoice={selectedInvoice}
        onClose={handleCloseDrawer}
      />
    </>
  )
}

export { InvoiceGenerationView }
